import React, {Component} from 'react';
import {connect} from 'react-redux';

import styled from 'styled-components'
import {Avatar} from "reakit";
import PropTypes from 'prop-types'
import {withFirebase} from "../Firebase";
import {Box, Button, Card, Flex, Heading, Text} from 'rebass';
import moment from 'moment'
import {getAudienceString} from "../../utils";
import {schoolSelectors} from "../../store/school";
// import {MobileHeader} from "../Base";

const PageTitle = styled(Heading)`
font-size: 21px;
font-weight: 700;
margin-top: 0px;
color: #263039;
 & > span {
    color: #969a9b;
 }
`;

const Wrapper = styled(Flex)`
//min-height: 45vh;
`;
// const CardTitle = styled(Text)`
// font-size: 17px;
// font-weight: 700;
// color: #263039;
// `

const MetaText = styled(Text)`
font-size: 12px;
font-weight: 300;
color: #969a9b;
`;

const ContentText = styled(Text)`
  font-size: 15px;
  font-weight: 400;
  color: #263039;
`;


class ApprovalCard extends Component {

	state = {
		owner: {first_name: '', last_name: '', id: 1}
	};

	componentDidMount() {
		//this.fetchOwnerInfo()
	}

	fetchOwnerInfo = async () => {
		const {post, firebase} = this.props;
		try {
			if (post.creator_is_student) {
				let studentRef = await firebase.student(post.creator_uid).get();

				const data = {id: studentRef.id, ...studentRef.data()};
				this.setState({owner: data})
			} else {
				let studentRef = await firebase.faculty(post.creator_uid).get();

				const data = {id: studentRef.id, ...studentRef.data()};
				this.setState({owner: data})
			}
		} catch (e) {
			//console.log(e)
		}
	};

	handleApprovePost = async () => {
		const {post, isFaculty, profile} = this.props;
		if (isFaculty) {
			try {
				let postRef = this.props.firebase.post(post.id);
				postRef.update({
					status: 1,
					status_updated_by: profile.id
				})
				// history.push('/app/home')
			} catch (e) {
				//console.log(e)
			}
		}
	};

	handleDecline = async () => {
		const {post, isFaculty, profile} = this.props;
		if (isFaculty) {
			try {
				let postRef = this.props.firebase.post(post.id);
				postRef.update({
					status: 2,
					status_updated_by: profile.id

				})
				// history.push('/app/home')
			} catch (e) {
				//console.log(e)
			}
		}
	};

	render() {
		const {owner} = this.state;

		const {loading, post, isFaculty, profile, schoolInfo} = this.props;
		let date;
		if (!loading) {
			date = moment.unix(post.post_time).fromNow()

		}
		let name = owner.first_name + ' ' + owner.last_name;
		if (profile !== undefined || profile !== null ){
			if(post.creator_uid === profile.id) {
				name = 'Me'
			}
		}

		let audienceResult = []
		let audienceString = null

		if (post) {
			audienceResult = getAudienceString(post, schoolInfo)
		}

		if(audienceResult.length > 0){
			audienceString = `Audience: ${audienceResult.join(', ')}`
		}

		return (
			<Card p={[0, 1]} variant='approve' boxShadow={'main'}>

				<Flex width={1} justifyContent={'center'}>
				</Flex>
				<Text color={'meta'} pl={3} pt={3} pb={0}>{audienceString}</Text>

				<PageTitle pl={3} pt={0}>{loading ? <Text>Loading...</Text> : post.title || 'Title'}</PageTitle>
				{/*<Wrapper  p={1} height={0.5}>*/}

				<Wrapper flexDirection={'column'} alignItems='stretch' jusitfyContent={'space-between'} px={3} height={0.5}>

					<Flex >
						<Box>
							<Avatar width={'31px'} height={'31px'} backgroundColor={'#707070'}/>
						</Box>
						<Box ml={2}>
							<Text>{name}</Text>
							<MetaText>{date}</MetaText>
						</Box>
					</Flex>

					<Box height={0.8} mt={2} style={{flexGrow: 1}}>
						<ContentText>
							{loading ? <Text>Loading...</Text> : post.message}
						</ContentText>
					</Box>
					<Box>
						{profile && profile.is_admin && isFaculty && post.status === 0 &&
						<Flex mt={3} justifyContent={'center'}>

							<Button variant={'main'} bg={'green'} onClick={this.handleApprovePost}>Approve</Button>
							<Button variant={'main'} bg={'red'} ml={1} onClick={this.handleDecline}>Decline</Button>
						</Flex>
						}
					</Box>
				</Wrapper>
			</Card>
		);
	}
}

ApprovalCard.propTypes = {
	post: PropTypes.object,
	profile: PropTypes.object,
	isFaculty: PropTypes.bool
};

const mapStateToProps = state => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school),

});

export default withFirebase(connect(mapStateToProps)(ApprovalCard))
